import { collection, getDocs, limit, query } from 'firebase/firestore';
import { auth, db, firebaseConfig } from '../lib/firebase/config';

export const verifyFirebaseSetup = async () => {
  console.log('Starting Firebase verification...');

  // Validate the config the app actually initialized with, not the raw env vars.
  // firebaseConfig falls back to hardcoded public values, so a missing VITE_*
  // entry must not block startup when a usable fallback exists.
  console.log('Checking Firebase config...');
  const config = firebaseConfig;

  // Log each config value (but mask the API key)
  Object.entries(config).forEach(([key, value]) => {
    console.log(`${key}: ${key === 'apiKey' ? '***' : value}`);
  });

  const missingVars = Object.entries(config)
    .filter(([_, value]) => !value)
    .map(([key]) => key);

  if (missingVars.length > 0) {
    throw new Error(`Missing Firebase config values: ${missingVars.join(', ')}`);
  }

  // Check Firebase initialization
  console.log('Checking Firebase initialization...');
  if (!auth) {
    throw new Error('Firebase Auth is not initialized');
  }
  console.log('✅ Firebase Auth is initialized');

  if (!db) {
    throw new Error('Firebase Firestore is not initialized');
  }
  console.log('✅ Firebase Firestore is initialized');

  // Check if user is authenticated
  const currentUser = auth.currentUser;
  console.log('Current user:', currentUser ? 'Authenticated' : 'Not authenticated');

  // Test Firestore connection
  console.log('Testing Firestore connection...');
  try {
    // First try to access the products collection since it's publicly readable
    const testQuery = query(collection(db, 'products'), limit(1));
    await getDocs(testQuery);
    console.log('✅ Successfully connected to Firestore');
  } catch (error) {
    console.error('❌ Firestore connection failed:', error);
    
    // If the error is about permissions, provide more helpful message
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    if (errorMessage.includes('permission') || errorMessage.includes('unauthorized')) {
      throw new Error(
        'Firestore access denied. This could be because:\n' +
        '1. You are not logged in (for protected collections)\n' +
        '2. The Firestore rules need to be deployed\n' +
        '3. The collection you are trying to access does not exist'
      );
    }
    
    throw new Error(`Failed to connect to Firestore: ${errorMessage}`);
  }

  console.log('✅ All Firebase verification checks passed');
  return true;
}; 